import { render, staticRenderFns } from "./portfolio-project.vue?vue&type=template&id=124d0a6e&scoped=true&lang=pug"
import script from "./portfolio-project.vue?vue&type=script&lang=ts"
export * from "./portfolio-project.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124d0a6e",
  null
  
)

export default component.exports